export enum AdminUserPodType {
    Pod1 = 1,
    Pod2 = 2,
    Pod3 = 3,
    Pod4 = 4,
    Pod5 = 5,
    Pod6 = 6,
    Pod7 = 7,
    Pod8 = 8,
    Pod9 = 9,
    Pod10 = 10,
}

export const AdminUserPodTypeOptions = [
    { id: AdminUserPodType.Pod1, name: '1', sortOrder: 1 },
    { id: AdminUserPodType.Pod2, name: '2', sortOrder: 2 },
    { id: AdminUserPodType.Pod3, name: '3', sortOrder: 3 },
    { id: AdminUserPodType.Pod4, name: '4', sortOrder: 4 },
    { id: AdminUserPodType.Pod5, name: '5', sortOrder: 5 },
    { id: AdminUserPodType.Pod6, name: '6', sortOrder: 6 },
    { id: AdminUserPodType.Pod7, name: '7', sortOrder: 7 },
    { id: AdminUserPodType.Pod8, name: '8', sortOrder: 8 },
    { id: AdminUserPodType.Pod9, name: '9', sortOrder: 9 },
    { id: AdminUserPodType.Pod10, name: '10', sortOrder: 10 },
];
